import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-navy-900 text-white/70 font-sans selection:bg-gold/30 flex flex-col" data-id="element-210">
      <Navbar data-id="element-211" />
      <main className="flex-grow" data-id="element-212">{children}</main>
      <Footer data-id="element-213" />
    </div>;
}